import React from "react";
import styles from "./FirstPageTopSection.module.css";

interface TopSectionProps {
  logoSrc: string;
  title: string;
  subtitle: string;
}

const TopSection: React.FC<TopSectionProps> = ({
  logoSrc,
  title,
  subtitle,
}) => {
  return (
    <div className={styles.topSection}>
      <div className={styles.logoContainer}>
        <img src={logoSrc} alt="Logo" className={styles.logo} />
      </div>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
};

export default TopSection;
